import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from '@common-fe/common-fe';

import { PayoutDefinitionField, PayoutDefinitionFormValues } from '../../../PayoutDefinitionSetup.types';
import { MAX_COLUMNS_COUNT, MIN_COLUMNS_COUNT } from '../components/PayoutOrder.constants';

const usePayoutOrderColumns = () => {
  const { setValue } = useFormContext<PayoutDefinitionFormValues>();
  const columnsCount = useWatch<PayoutDefinitionFormValues, PayoutDefinitionField.columnsCount>({
    name: PayoutDefinitionField.columnsCount,
  });

  const canAddColumn = columnsCount < MAX_COLUMNS_COUNT;
  const canRemoveColumn = columnsCount > MIN_COLUMNS_COUNT;

  const columns = useMemo(() => Array.from({ length: columnsCount }, (_, idx) => idx + 1), [columnsCount]);

  const handleAddColumn = useCallback(() => {
    setValue(PayoutDefinitionField.columnsCount, Math.min(columnsCount + 1, MAX_COLUMNS_COUNT), {
      shouldDirty: true,
    });
  }, [setValue, columnsCount]);

  const handleRemoveColumn = useCallback(
    (_columnIndex: number) => {
      setValue(PayoutDefinitionField.columnsCount, Math.max(columnsCount - 1, MIN_COLUMNS_COUNT), {
        shouldDirty: true,
      });
    },
    [setValue, columnsCount]
  );

  return {
    columns,
    columnsCount,
    canAddColumn,
    canRemoveColumn,
    handleAddColumn,
    handleRemoveColumn,
  };
};

export default usePayoutOrderColumns;
